import { Flex, Typography } from "antd"

import styles from "./cells.module.less"

const { Text } = Typography

// A channel or status group in a table: a round marker in the group's colour, then its name, cut
// with an ellipsis in a narrow column (DAA-1-24). The colour is the group's in every chart (DAA-1-23).
const GroupMarker = ({ color, name }) => (
  <Flex align="center" gap={8}>
    <span className={styles.marker} style={{ background: color }} />
    <Text ellipsis={{ tooltip: name }}>{name}</Text>
  </Flex>
)

export default GroupMarker
